import styled from 'styled-components';

export const WidgetRotationGalleryForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
`;
